import { ToggleButtonProps } from "@mui/material";
import { AppSidePanelIcon } from "../../Icon/AppSidePanelIcon";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToggleButton } from "../AppToggleButton";

export const SidePanelToggleButton = (props: ToggleButtonProps & { right?: boolean; }) => {
    const { right, ...restProps } = props;

    return (
        <AppToggleButton
            sx={{ marginRight: ".5rem" }}
            {...restProps}
            tooltip={Translations.ToggleSidePanel}
        >
            <AppSidePanelIcon right={right} />
        </AppToggleButton>
    );
};
